<template>
    <kt-panel>
        <div class="fh-datatable" >
            <table class="table table-striped">
                <thead>
                <tr style="font-size: 0.89rem;">
                    <td style="text-align: center; width:70px">#</td>
                    <td style="text-align: center">{{ $t('security.full_name') }}</td>
                    <td style="text-align: center">{{ $t('security.created_date') }}</td>
                    <td style="text-align: center">{{ $t('security.ip') }}</td>
                    <td style="text-align: center">{{ $t('datatable.actions') }}</td>
                </tr>
                </thead>
                <tbody  v-if="black_ips.length > 0">
                <tr v-bind:key="index" v-for="(user, index) in black_ips">
                    <td style="text-align: center">{{ user.hashid }}</td>
                    <td style="text-align: center">{{ user.full_name }}</td>
                    <td style="text-align: center">{{ user.created_date }}</td>
                    <td style="text-align: center">{{ user.ip }}</td>
                    <td style="text-align: center">
                        <button type="button" class="btn btn-sm btn-clean btn-icon btn-icon-sm" data-toggle="dropdown" data-target="#myModal">
                            <i class="fa fa-cog"></i>
                        </button>
                        <div class="dropdown-menu">
                            <button
                                    id="add_To_SuspectedIPs"
                                    @click="deleteFromBlackIPs(user.hashid)"
                                    class="dropdown-item"
                            >
                                {{ $t('security.blackList.deleteFromBlackIPs') }}
                            </button>
                            <button
                                    id="add_To_BlackIPs"
                                    @click="addToSuspectedIPs(user.hashid)"
                                    class="dropdown-item"
                            >
                                {{ $t('security.blackList.addToSuspectedIPs') }}
                            </button>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="loader" style="display:none"></div>
    </kt-panel>
</template>

<script>
    import { mapGetters } from 'vuex'
    import {blackListService} from "@/common/api.service";
    import toastr from "toastr";
    import $ from "jquery";

    export default {

        computed: {
            ...mapGetters('blackList', ['black_ips', 'status']),
            toastr() {
                toastr.options = {
                    closeButton: true,
                    positionClass: "toast-top-left",
                    preventDuplicates: false,
                    rtl: false
                }

                return toastr
            }
        },
        mounted() {
            this.$store.dispatch('blackList/fetchBlackIps')
        },
        methods: {
            deleteFromBlackIPs(hashid) {
                $('.loader').addClass('disp_block')
                blackListService.deleteFromBlackIPs(hashid).then(response => {
                    this.$store.dispatch('blackList/fetchBlackIps')
                    this.toastr.success(response.data.message)
                    $('.loader').removeClass('disp_block')

                })
            },
            addToSuspectedIPs(hashid) {
                $('.loader').addClass('disp_block')
                blackListService.addToSuspectedIPs(hashid).then(response => {
                    this.$store.dispatch('blackList/fetchBlackIps')
                    this.toastr.success(response.data.message)
                    $('.loader').removeClass('disp_block')
                    this.$store.dispatch('blackList/fetchSuspectedIps')
                })
            },
        }
    }
</script>

<style>
    .disp_block {
        display: block !important;
    }
    .loader {
        border: 10px solid #f3f3f3;
        border-radius: 50%;
        border-top: 10px solid #3498db;
        width: 60px;
        height: 60px;
        -webkit-animation: spin 2s linear infinite; /* Safari */
        animation: spin 1s linear infinite;
        margin: auto;
        top: 50%;
        right: 50%;
        position: absolute;
    }

    /* Safari */
    @-webkit-keyframes spin {
        0% { -webkit-transform: rotate(0deg); }
        100% { -webkit-transform: rotate(360deg); }
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
</style>